import './OfferSearchActiveFilters.scss'

import {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {X} from 'react-feather'

import withManagers from '../../../../../HOC/withManagers.jsx'

import {
  CITY_FILTER_KEY,
  DISTANCE_FILTER_KEY,
  MANAGER_FILTER_KEY,
  MY_APPLICATION_FILTER_KEY,
  RELOCATION_FILTER_KEY,
  TYPE_FILTER_KEY,
  UNIVERSE_FILTER_KEY,
} from '../../../../../../shared/constants/filters.js'

class OfferSearchActiveFilters extends PureComponent {
  static propTypes = {
    isAdmin: PropTypes.bool,
    isManager: PropTypes.bool,
    isOnlyMy: PropTypes.bool,
    managers: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    requirementChoices: PropTypes.array,
    searchQuery: PropTypes.object,
    topologies: PropTypes.array,
    universes: PropTypes.array,
  }

  static defaultProps = {
    isAdmin: false,
    isManager: false,
    isOnlyMy: false,
    managers: [],
    requirementChoices: [],
    searchQuery: {},
    topologies: [],
    universes: [],
  }

  removeFilter = (keys) => {
    const data = this.props.searchQuery
    ;[].concat(keys).forEach((key) => delete data[key])
    this.props.onChange(data)
  }

  removeKeyword = (keyword) => {
    const data = this.props.searchQuery
    const remaining = (data.keywords || []).filter((item) => item !== keyword)
    if (remaining.length) {
      data.keywords = remaining
    } else {
      delete data.keywords
      delete data.requirements
    }
    this.props.onChange(data)
  }

  removeTopology = (value) => {
    this.props.onChange({[TYPE_FILTER_KEY]: ((this.props.searchQuery?.[TYPE_FILTER_KEY] ?? 0) & ~value) >>> 0})
  }

  getChips = () => {
    const {isAdmin, isManager, isOnlyMy, managers, requirementChoices, searchQuery, topologies, universes} = this.props
    const effective = searchQuery ?? {}
    const chips = []

    if (effective.keywords?.length) {
      const requirementValue = effective.requirements ? parseInt(effective.requirements, 10) : null
      const requirementChoice = requirementValue ? requirementChoices.find((choice) => choice.value === requirementValue) : null

      effective.keywords.forEach((keyword) => {
        chips.push({
          key: `keyword-${keyword}`,
          label: requirementChoice ? `${requirementChoice.text} : ${keyword}` : keyword,
          onRemove: () => this.removeKeyword(keyword),
        })
      })
    }

    if (effective[UNIVERSE_FILTER_KEY]) {
      const universe = universes.find((item) => Number(item.id) === Number(effective[UNIVERSE_FILTER_KEY]))
      chips.push({
        key: 'universe',
        label: universe?.name ?? 'Univers',
        removable: false,
      })
    }

    if (isAdmin) {
      const type = effective[TYPE_FILTER_KEY] ?? 0
      topologies.forEach((pair) => {
        pair.forEach((item) => {
          if (type & item.value) {
            chips.push({
              key: `topology-${item.name}`,
              label: item.label,
              onRemove: () => this.removeTopology(item.value),
            })
          }
        })
      })
    }

    if (effective[CITY_FILTER_KEY]) {
      chips.push({
        key: 'city',
        label: effective[CITY_FILTER_KEY],
        onRemove: () => this.removeFilter([CITY_FILTER_KEY, 'latitude', 'longitude']),
      })
    }

    if (effective[RELOCATION_FILTER_KEY] === '1' || effective[RELOCATION_FILTER_KEY] === 1) {
      chips.push({
        key: 'relocation',
        label: 'Mobile partout en France',
        onRemove: () => this.removeFilter(RELOCATION_FILTER_KEY),
      })
    }

    if (effective[DISTANCE_FILTER_KEY]) {
      chips.push({
        key: 'distance',
        label: `${effective[DISTANCE_FILTER_KEY]} km`,
        onRemove: () => this.removeFilter(DISTANCE_FILTER_KEY),
      })
    }

    if (isAdmin && isManager && effective[MANAGER_FILTER_KEY]) {
      const manager = managers.find((item) => Number(item.id) === Number(effective[MANAGER_FILTER_KEY]))
      chips.push({
        key: 'manager',
        label: manager?.fullname ?? effective[MANAGER_FILTER_KEY],
        onRemove: () => this.removeFilter(MANAGER_FILTER_KEY),
      })
    }

    if (isOnlyMy && (effective[MY_APPLICATION_FILTER_KEY] === '1' || effective[MY_APPLICATION_FILTER_KEY] === 1)) {
      chips.push({
        key: 'onlyMyAnswers',
        label: 'Offres de mission où j\'ai postulé',
        onRemove: () => this.removeFilter(MY_APPLICATION_FILTER_KEY),
      })
    }

    return chips
  }

  render() {
    const chips = this.getChips()
    if (!chips.length) return null

    return (
      <div className="offer-search-active-filters">
        {chips.map((chip) => (
          chip.removable === false ? (
            <span key={chip.key} className="offer-search-active-filters__chip offer-search-active-filters__chip--locked">
              {chip.label}
            </span>
          ) : (
            <button
              type="button"
              key={chip.key}
              className="offer-search-active-filters__chip"
              onClick={chip.onRemove}
            >
              {chip.label}
              <X size={12} />
            </button>
          )
        ))}
      </div>
    )
  }
}

export default withManagers(connect(
  (state) => ({
    universes: state.universe.universes,
  })
)(OfferSearchActiveFilters))
